import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';

export interface UpdateInvestigationChecklistStepCommand {
  readonly investigationId: string;
  readonly stepId: string;
  readonly isCompleted: boolean;
}
export interface UpdateInvestigationChecklistStepResult { success: boolean; }

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationChecklistStepUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: UpdateInvestigationChecklistStepCommand): Observable<UpdateInvestigationChecklistStepResult> {
    this._state.setUpdatingChecklistStep(true);
    this._state.setErrorChecklistSteps(null);
    return this._repository.updateChecklistStep(command.investigationId, command.stepId, command.isCompleted).pipe(
      tap(() => {
        this._state.updateChecklistStepCompletion(command.stepId, command.isCompleted);
        this._state.setUpdatingChecklistStep(false);
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorChecklistSteps(error.message || 'Failed to update checklist step');
        this._state.setUpdatingChecklistStep(false);
        return throwError(() => error);
      }),
    );
  }
}
